import Lottie from "lottie-react";
import React from "react";
import { useInView } from "react-intersection-observer";
import T_T from "../../Asset/json/T&T.json";
import { ShinyText } from "./Home";
import DownloadButton from "../../component/DownloadButton/DownloadButton";

const VoiceTypeOrTranslateSection = () => {
  const { ref: videoRef, inView: videoView } = useInView({
    triggerOnce: true,
    threshold: 0.5,
  });
  const { ref: headingRef, inView: headingView } = useInView({
    triggerOnce: true,
    threshold: 0.5,
  });
  const { ref: buttonRef, inView: buttonView } = useInView({
    triggerOnce: true,
    threshold: 0.5,
  });
  return (
    <div className="flex md:flex-row flex-col-reverse items-center md:gap-2 gap-10 xl:pt-10 lg:pt-8 md:pt-6 xl:pb-10 lg:pb-8 z-[5] md:pb-6 lg:px-10 md:px-6 px-0 ">
      <div className=" flex-1 flex justify-center items-center">
        {/* <div
          ref={videoRef}
          className={`lg:w-[85%] md:w-[90%] w-full xl:rounded-3xl rounded-2xl overflow-hidden transition-opacity duration-500 ${
            videoView ? `animate-slideUp` : "opacity-0"
          } `}
        >
          <Lottie animationData={T_T} loop style={{ width: "100%" }} />
        </div> */}
        <div
          ref={videoRef}
          className={`${
            videoView ? `animate-slideUp z-[3] anim-preserve` : "opacity-0 z-0"
          }  lg:w-[85%] md:w-[90%] w-full xl:rounded-3xl rounded-2xl overflow-hidden  `}
        >
          <video
            className={`w-full scale-105 `}
            src="https://pub-25f4599302a64a3dab9e149b2b5f9a0f.r2.dev/videos/TRANSCRIBE%20OR%20TRANSLATE.mp4"
            autoPlay
            loop
            muted
            playsInline
            webkit-playsinline="true"
            preload="metadata"
          />
        </div>
      </div>
      <div className=" flex-1 flex flex-col md:items-start items-center xl:gap-5 lg:gap-4  gap-3">
        <div
          ref={headingRef}
          className={`xl:text-[3.125rem]  lg:text-[2.8rem] md:text-[2.4rem] text-[2.625rem] md:text-left text-center  font-jakarta font-bold ${
            headingView
              ? `animate-slideUp z-[3] anim-preserve`
              : "opacity-0 z-0"
          }`}
        >
          <ShinyText
            text="Voice Type "
            speed={5}
            className="custom-class text-wrap"
          />
          Or Translate
        </div>
        <div className=" xl:text-[1.438rem] z-[4] relative bg-white lg:text-[1.2rem] md:text-[1.15rem] text-[1.313rem] md:text-left text-center leading-snug text-[#00000099] font-inter">
          Choose voice typing to get text in the same language{" "}
          <br className="lg:flex hidden" /> as you speak, or Translate to
          convert any speech into <br className="lg:flex hidden" />
          English automatically. Zero Typing handles it all with{" "}
          <br className="lg:flex hidden" /> precision.
        </div>
        <DownloadButton ref={buttonRef} view={buttonView} />
      </div>
    </div>
  );
};

export default VoiceTypeOrTranslateSection;
